<template>
  <div class="p-4">
    <h3 class="mt-4">
      {{ category.title }}
    </h3>

    <b-alert class="mb-0" variant="warning" :show="!isLoading && rowData.length === 0">
      No organizations in this category at this time
    </b-alert>

    <ifac-page-size-select
      v-show="rowData.length > 0"
      v-model="pageSizeChoice"
      :allow-all="allowAll"
      @change="onPageSizeChanged"
    />

    <ag-grid-vue
      v-show="rowData.length > 0"
      class="ag-theme-alpine"
      :pagination="true"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="rowData"
      :gridOptions="gridOptions"
      domLayout="autoHeight"
      :paginationPageSize="paginationPageSize"
      :getRowStyle="getRowStyle"
      @grid-ready="onGridReady"
      @cellClicked="onRowClicked"
    />
  </div>
</template>

<script>
import Base from '@/views/components/officials/mixins/Base';
import MemberOrganizations from '@/views/components/officials/mixins/MemberOrganizations';

export default {
  mixins: [Base, MemberOrganizations],
};
</script>
